import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, DataRoomCall } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomCallQuery(
	dataRoomGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<DataRoomCall[], unknown, DataRoomCall[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Calls.Root(dataRoomGuid),
		() => AxiosUtils.getResponseData<DataRoomCall[]>(api.get(CerebroApiEndpoints.Calls.Root(dataRoomGuid))),
		options
	);
}
